/**
 * Data Background Images Handler
 * 
 * Applies background images from data-bg-image attributes
 * Used for secure rendering without inline styles
 *
 * @package EVT Restaurant Builder
 * @since 1.0.0
 */

/**
 * Initialize data background image handling
 */
export function initDataBgImages() {
    // Find all elements with data-bg-image attribute
    const elements = document.querySelectorAll('[data-bg-image]');
    
    elements.forEach(element => {
        const bgImageUrl = element.getAttribute('data-bg-image');
        
        // Validate URL exists
        if (bgImageUrl && bgImageUrl.trim()) {
            // Apply background image via CSS
            element.style.backgroundImage = `url("${bgImageUrl}")`;
        }
    });
}

/**
 * Initialize data background images on page load and after dynamic content updates
 */
export function initDataBgImagesObserver() {
    // Handle initial page load
    initDataBgImages();
    
    // Handle dynamically added content (if needed)
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        // Check if the added node has data-bg-image
                        if (node.hasAttribute && node.hasAttribute('data-bg-image')) {
                            const bgImageUrl = node.getAttribute('data-bg-image');
                            if (bgImageUrl && bgImageUrl.trim()) {
                                node.style.backgroundImage = `url("${bgImageUrl}")`;
                            }
                        }
                        
                        // Check child elements for data-bg-image
                        const childElements = node.querySelectorAll && node.querySelectorAll('[data-bg-image]');
                        if (childElements) {
                            childElements.forEach(element => {
                                const bgImageUrl = element.getAttribute('data-bg-image');
                                if (bgImageUrl && bgImageUrl.trim()) {
                                    element.style.backgroundImage = `url("${bgImageUrl}")`;
                                }
                            });
                        }
                    }
                });
            }
        });
    });
    
    // Observe document for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}